import { OnInit } from '@angular/core';
import { Component } from '@angular/core';

@Component({
    selector: 'app-menu',
    templateUrl: './app.menu.component.html'
})
export class AppMenuComponent implements OnInit {

    model: any[] = [];

    ngOnInit() {
        this.model = [
            // {
            //     label: 'Dashboard',
            //     icon: 'pi pi-home',
            //     routerLink: ['/home']
            // },
            // { separator: true },
            {
                label: 'DRIVERS',
                icon: 'pi pi-users',
                routerLink: ['/home/drivers']
            },
            { separator: true },
            {
                label: 'VEHICLES',
                icon: 'pi pi-car',
                routerLink: ['/home/vehicles']
            },
            { separator: true },
            {
                label: 'QUOTATIONS',
                icon: 'pi pi-bars',
                routerLink: ['/home/quotations']
            },
            { separator: true },
            {
                label: 'ORDERS',
                icon: 'pi pi-shopping-bag',
                routerLink: ['/home/orders']
            },
            { separator: true },
            {
                label: 'PORTFOLIO',
                icon: 'pi pi-book',
                routerLink: ['/home/portfolio']
            }
        ];
    }
}
